module.exports = __webpack_public_path__ + "static/media/help.9b5ad943.png";